import { SampleRequiredFieldOption } from 'src/app/models/sampleValidationConfig.model';

/**
 * Selectable "Required Fields" for sample acceptance rules (DASH-2621, G7).
 * `value` is the canonical PascalCase `SampleDto` property name — the BE validates each
 * against `SampleDto` at save (case-sensitive) and enforces them on sample save, so these
 * MUST stay in exact PascalCase. `label` is a display key (translated in the UI).
 */
export const SAMPLE_REQUIRED_FIELD_OPTIONS: SampleRequiredFieldOption[] = [
    { value: 'StartDate', label: 'Start Date' },
    { value: 'EndDate', label: 'End Date' },
    { value: 'SampleDuration', label: 'Sample Duration' },
    { value: 'SampleNumber', label: 'Sample Number' },
    { value: 'SamplePreCal', label: 'Pre-Calibration' },
    { value: 'SamplePostCal', label: 'Post-Calibration' },
    { value: 'ShiftLength', label: 'Shift Length' },
    { value: 'SamplingEquipmentId', label: 'Sampling Equipment' },
    { value: 'SampleMediaId', label: 'Sample Media' },
    { value: 'CalibrationEquipmentId', label: 'Calibration Equipment' },
    { value: 'ManagingHygienistId', label: 'Managing Hygienist' },
    { value: 'SegId', label: 'SEG' },
    { value: 'ExposureTypicality', label: 'Exposure Typicality' },
    { value: 'SummaryNote', label: 'Summary Note' },
];

export const SAMPLE_VALIDATION_DEFAULTS = {
    maxCalDriftPercent: 0.10,
    maxNoiseDriftDb: 1.0,
} as const;

/**
 * Prefilled reason for the Void Sample popup when it is opened from the Calibration Variability
 * Exceeded warning (DASH-2731 on the detail page, DASH-3182 on the sample form). Shared so both
 * entry points offer the same editable text. Must stay in sync with the i18n key of the same name.
 */
export const CAL_DRIFT_VOID_REASON = 'Measured Calibration is greater than the tolerance value';

export const SECONDS_PER_MINUTE = 60;

/**
 * Client-side upper bounds for defence-in-depth (the BE is the true enforcement boundary).
 * Keep the form from sending absurd values that would only surface as confusing server errors.
 */
export const MAX_NOISE_DRIFT_DB = 200;
export const MAX_RUN_TIME_MINUTES = 1440; // 24 hours
